import { useState } from 'react';


function Test() {
  const [reader, setReader] = useState(null);
  const [cardInfo, setCardInfo] = useState('');

  const connectToReader = async () => {
    try {
      const device = await navigator.usb.requestDevice({ filters: [{}] });

      await device.open();
      const config = await device.selectConfiguration(1);

      await device.claimInterface(1);
      
      const res = await device.transferIn(0, 1000000)
      setReader(res);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const retrieveCardInfo = async () => {
    if (reader) {

      // Implement logic to send commands to the reader and retrieve card info
      // Update the cardInfo state with the retrieved information
    }
  };
  return (
    <div>
      <h1>CDG R301-C11 Smart Card Reader</h1>
      <button onClick={connectToReader}>Connect to Reader</button>
      <button onClick={retrieveCardInfo}>Retrieve Card Info</button>
      <p>{cardInfo}</p>
    </div>
  );
}

export default Test;
